import React from 'react';

import { Task } from '../myTasks2/components/Tabs/MyPortfolio/types/task';
import { WorkspaceTab } from './WorkspaceContainer';
import WorkspaceAllView from './WorkspaceAllView';
import WorkspaceTodosView from './WorkspaceTodosView';
import WorkspaceReviewView from './WorkspaceReviewView';

export interface WorkspaceViewProps {
  activeTab: WorkspaceTab;
  isReportsEnabled?: boolean;
  tasks: Task[];
  queryInfo: any;
}

const WorkspaceView: React.FC<WorkspaceViewProps> = ({
  activeTab,
  isReportsEnabled,
  tasks,
  queryInfo,
}) => {
  switch (activeTab) {
    case 'all':
      return (
        <>
          <WorkspaceAllView
            tasks={tasks || []}
            queryInfo={queryInfo}
            isReportsEnabled={isReportsEnabled}
          />
        </>
      );
    case 'todos':
      return (
        <>
          <WorkspaceTodosView
            tasks={tasks || []}
            queryInfo={queryInfo}
            isReportsEnabled={isReportsEnabled}
          />
        </>
      );
    case 'review':
      return (
        <>
          <WorkspaceReviewView
            tasks={tasks || []}
            queryInfo={queryInfo}
            isReportsEnabled={isReportsEnabled}
          />
        </>
      );
    default:
      return (
        <>
          <WorkspaceAllView
            tasks={tasks || []}
            queryInfo={queryInfo}
            isReportsEnabled={isReportsEnabled}
          />
        </>
      );
  }
};

export default WorkspaceView;
